import type { ComponentType, ReactNode } from 'react'
import { Suspense } from 'react'

import { Spinner } from '@/components/ui/spinner'
import { useI18n } from '@/i18n/useI18n'

function RouteLoading() {
  const { t } = useI18n()
  return (
    <div
      className="grid min-h-[40vh] place-items-center p-6"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <Spinner className="size-6" />
        <span className="text-sm">{t('common.loading')}</span>
      </div>
    </div>
  )
}

interface LazyRouteProps {
  Component: ComponentType
  fallback?: ReactNode
}

export function LazyRoute({ Component, fallback }: LazyRouteProps) {
  return (
    <Suspense fallback={fallback ?? <RouteLoading />}>
      <Component />
    </Suspense>
  )
}